












import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company, FinanceInfo, CompanyGradeReport } from '@/utils/Interfaces'
import BaoCaoGeneric from '@/components/BaoCaoGeneric.vue'

declare interface FormattedReport extends CompanyGradeReport {
  company: Company['name'];
  doanh_thu_ke_hoach: CompanyGradeReport['doanh_thu_ke_hoach'];
  doanh_thu_thuc_hien: CompanyGradeReport['doanh_thu_thuc_hien'];
  xep_loai_chi_tieu_1: CompanyGradeReport['xep_loai_chi_tieu_1'];
  loi_nhuan_sau_thue_ke_hoach: CompanyGradeReport['loi_nhuan_sau_thue_ke_hoach'];
  loi_nhuan_sau_thue_thuc_hien: CompanyGradeReport['loi_nhuan_sau_thue_thuc_hien'];
  von_csh_ke_hoach: CompanyGradeReport['von_csh_ke_hoach'];
  von_csh_thuc_hien: CompanyGradeReport['von_csh_thuc_hien'];
  ty_suat_loi_nhuan_ke_hoach: CompanyGradeReport['ty_suat_loi_nhuan_ke_hoach'];
  ty_suat_loi_nhuan_thuc_hien: CompanyGradeReport['ty_suat_loi_nhuan_thuc_hien'];
  xep_loai_chi_tieu_2: CompanyGradeReport['xep_loai_chi_tieu_2'];
  tai_san_ngan_han: CompanyGradeReport['tai_san_ngan_han'];
  no_ngan_han: CompanyGradeReport['no_ngan_han'];
  tsnh_tren_nnh: CompanyGradeReport['tsnh_tren_nnh'];
  no_qua_han: CompanyGradeReport['no_qua_han'];
  xep_loai_chi_tieu_3: CompanyGradeReport['xep_loai_chi_tieu_3'];
  xep_loai_chi_tieu_4: CompanyGradeReport['xep_loai_chi_tieu_4'];
  xep_loai_chi_tieu_5: CompanyGradeReport['xep_loai_chi_tieu_5'];
  xep_loai_doanh_nghiep: CompanyGradeReport['xep_loai_doanh_nghiep'];
}


@Component({
  components: {
    BaoCaoGeneric,
  }
})
export default class BaoCaoXepLoaiDN extends Vue {
  @Prop(Array) readonly reports!: Array<CompanyGradeReport>

  reportType = 'BaoCaoXepLoaiDN'

  headerMapper: { [index: string]: string } = {
    company: 'Công ty',
    doanh_thu_ke_hoach: 'Doanh thu và thu nhập khác kế hoạch',
    doanh_thu_thuc_hien: 'Doanh thu và thu nhập khác thực hiện',
    xep_loai_chi_tieu_1: 'Xếp loại chỉ tiêu 1',
    loi_nhuan_sau_thue_ke_hoach: 'Lợi nhuận sau thuế kế hoạch',
    loi_nhuan_sau_thue_thuc_hien: 'Lợi nhuận sau thuế thực hiện',
    von_csh_ke_hoach: 'Vốn chủ sở hữu bình quân kế hoạch',
    von_csh_thuc_hien: 'Vốn chủ sở hữu bình quân thực hiện',
    ty_suat_loi_nhuan_ke_hoach: 'Tỷ suất lợi nhuận trên vốn kế hoạch',
    ty_suat_loi_nhuan_thuc_hien: 'Tỷ suất lợi nhuận trên vốn thực hiện',
    xep_loai_chi_tieu_2: 'Xếp loại chỉ tiêu 2',
    tai_san_ngan_han: 'Tài sản ngắn hạn',
    no_ngan_han: 'Nợ ngắn hạn',
    tsnh_tren_nnh: 'Tài sản ngắn hạn trên nợ ngắn hạn',
    no_qua_han: 'Nợ quá hạn',
    xep_loai_chi_tieu_3: 'Xếp loại chỉ tiêu 3',
    xep_loai_chi_tieu_4: 'Xếp loại chỉ tiêu 4',
    xep_loai_chi_tieu_5: 'Xếp loại chỉ tiêu 5',
    xep_loai_doanh_nghiep: 'Xếp loại doanh nghiệp',
  }

  formatMapper: { [index: string]: string | null } = {
    company: 'link',
    doanh_thu_ke_hoach: 'money',
    doanh_thu_thuc_hien: 'money',
    xep_loai_chi_tieu_1: 'select',
    loi_nhuan_sau_thue_ke_hoach: 'money',
    loi_nhuan_sau_thue_thuc_hien: 'money',
    von_csh_ke_hoach: 'money',
    von_csh_thuc_hien: 'money',
    ty_suat_loi_nhuan_ke_hoach: 'percentage',
    ty_suat_loi_nhuan_thuc_hien: 'percentage',
    xep_loai_chi_tieu_2: 'select',
    tai_san_ngan_han: 'money',
    no_ngan_han: 'money',
    tsnh_tren_nnh: 'number',
    no_qua_han: 'money',
    xep_loai_chi_tieu_3: 'select',
    xep_loai_chi_tieu_4: 'select',
    xep_loai_chi_tieu_5: 'select',
    xep_loai_doanh_nghiep: 'select',
  }

  choicesMapper: { [index: string]: unknown } = {
    xep_loai_chi_tieu_1: ['A', 'B', 'C'],
    xep_loai_chi_tieu_2: ['A', 'B', 'C'],
    xep_loai_chi_tieu_3: ['A', 'B', 'C'],
    xep_loai_chi_tieu_4: ['A', 'B', 'C'],
    xep_loai_chi_tieu_5: ['A', 'B', 'C'],
    xep_loai_doanh_nghiep: ['A', 'B', 'C'],
  }

  get formattedReports () {
    const formattedReports: Array<FormattedReport> = []

    this.reports.forEach(report => {
      // @ts-expect-error
      const formattedReport: FormattedReport = {}

      // Get company name
      const financeInfo = report.finance_info as FinanceInfo
      const company = financeInfo.company as Company
      const companyName = company.name
      formattedReport.company = companyName

      // Get remaining info
      Object.assign(formattedReport, report)
      // Remove not needed info
      delete formattedReport.finance_info
      delete formattedReport.created_at
      delete formattedReport.updated_at

      formattedReports.push(formattedReport)
    })

    return formattedReports
  }
}
